// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__19QAD","inputWrap":"CustomTip_inputWrap__3oOg9"};